<template lang="pug">
  v-card.personalInnForm
    v-card-title
      h2 Вход в систему
    v-card-text.pa-0
      v-form(v-on:submit.prevent="checkBothInn" ref="form")
        v-layout(row justify-center)
          v-flex(xs10 sm8)
            span(v-bind:class="{'upperLine-error': hasError}").upperLine ИНН Сотрудника
            v-text-field(
              ref="personalInn",
              v-bind:class="{'has-error': hasError}",
              v-model="innPersonal",
              :error-messages="error",
              :success-messages="viewInnInfo",
              name="innPersonal",
              single-line,
              outline,
              maxlength="14",
              mask="##############",
              counter="14",
              type="text",
              autocomplete="off").pb-5
            v-layout(justify-center)
              v-btn(
                large
                id="loginPersonalBtn",
                name="loginPersonalBtn",
                color="primary",
                type="submit",
                :loading="loadingBtn",
                :disabled="isDisableBtn") Войти
</template>

<script>
export default {
  name: 'LoginPersonal',
  data() {
    return {
      innPersonal: '',
      error: '',
      hasError: false,
      isDisableBtn: true
    }
  },
  mounted() {
    this.$refs.personalInn.$refs.input.focus()
    this.$store.dispatch('SHOW_BACK_BTN', true)
    this.subscribeToMutations()
  },
  watch: {
    innPersonal(val) {
      if (val.length === 14) {
        this.$store.dispatch('GET_INN_INFO', val)
      }
      this.clearErrors()
      this.$store.state.auth.innInfo = ''
      this.isDisableBtn = val.length !== 14
    }
  },
  computed: {
    viewInnInfo() {
      return this.$store.state.auth.innInfo.name
    },
    loadingBtn() {
      return this.$store.state.auth.loading.checkPersonalInnLoading
    }
  },
  methods: {
    clearErrors() {
      this.$refs.form.resetValidation()
      this.hasError = false
      this.error = ''
      this.$store.state.auth.errors.innInfoError = ''
    },
    checkError() {
      if (this.innPersonal === '') {
        this.hasError = true
        this.error = 'Введены некоректные данные'
      } else {
        this.error = null
        this.hasError = false
      }
    },
    checkBothInn() {
      this.checkError()
      if (!this.error) {
        const data = { innEmployee: this.innPersonal }
        this.$store.dispatch('CHECK_PERSONAL_INN', data).then(() => {
          this.$store.state.auth.innInfo = ''
        })
      }
    },
    subscribeToMutations() {
      this.$store.subscribe((mutation, state) => {
        switch (mutation.type) {
          case 'CHECK_PERSONAL_INN_ERROR':
            const personalInnError = this.$store.state.auth.errors.checkPersonalInnError
            this.hasError = true
            this.error = personalInnError
            break
          case 'GET_INN_INFO_ERROR':
            const innInfoError = this.$store.state.auth.errors.innInfoError
            this.hasError = true
            this.error = innInfoError
            break
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  padding: 32px 16px;
  #loginPersonalBtn {
    border-radius: 4px;
    max-width: 190px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AuthPages/LoginPersonal.vue